module.exports = __webpack_public_path__ + "static/img/ikonaNotatnik-ON.b1a27759.png";